function Footer() {
    return (
        <footer 
            className="footer"
            style={{ paddingTop: 20, paddingBottom: 20 }}    
        >
            <div className="content has-text-centered">
                <p>
                    &copy; DEVIYENT 2019-2021 
                </p>
            </div>
        </footer>
    )
}

export default Footer
